import { createAction } from '@reduxjs/toolkit';

export const MARK_READ_ACTION_TYPE = 'saga/markRead';
export const markReadAction = createAction(MARK_READ_ACTION_TYPE);
